import { combineReducers } from 'redux';

const requestError = (state = {}, action) => {
    switch (action.type) {
        case 'UPDATE_REQUEST_ERROR': {
            return {
                ...state,
                [action.data.error_id]: action.data,
            }
        }
        default: {
            return state;
        }
    }
}

export default requestError;
